import { BehaviorSubject, Subject, Observable, ReplaySubject, AsyncSubject, lastValueFrom, pipe, last } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, RouterStateSnapshot } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie';

@Injectable()
export class ShareService {
    
    private emitChangeSource = new Subject<any>();
    private emitOnSearchList = new BehaviorSubject(false);
    private emitRouteChangeSource = new Subject<any>();
    public emitFilterChangeSource = new Subject<any>();

    public clientCurrencyChange = new Subject<any>();

    private pickedObject: any;

    clientCurrencyEmit$ = this.clientCurrencyChange.asObservable();
    changeEmitted$ = this.emitChangeSource.asObservable();
    changeEmittedrule$ = this.emitChangeSource.asObservable();
    emitRouteChangeSource$ = this.emitRouteChangeSource.asObservable();
    emitFilterChangeSource$ = this.emitFilterChangeSource.asObservable();

    emitOnSearchList$ = this.emitOnSearchList.asObservable();

    constructor(
        private router: Router,
        private _cookieService: CookieService
    ){
        this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((navs: NavigationEnd) => {
            if(this._cookieService.get("__defaultSettings")){
                this.clientCurrencyChange.next(JSON.parse(this._cookieService.get("__defaultSettings")));
            }            
        });
  
    }

    getclientCurrency(): Observable<any>{
        return this.clientCurrencyChange.asObservable();
    }

    emitChange(change: any) {
        this.pickedObject = change;
        this.emitChangeSource.next(change);
    }

    getPicked() {
        return this.pickedObject;
    }

    emitOnSearchListNext(change: any) {
        this.emitOnSearchList.next(change);
    }

    emitRouteChange(index: number, changeRoute: boolean = false) {
        const route = {
            index: index,
            changeRoute: changeRoute
        }
        this.emitRouteChangeSource.next(route);
    }
}